import { AdobeEventHandler, AdobeEvent, Mutation, Mapping } from 'pkg-trinity-client'
import { get } from 'lodash'
import * as Helpers from './helpers'
import { State } from './vuex'

export const mapping: Mapping = [
  {
    category: 'inspiration',
    pages: [
      {
        regex: /^\/entdecken/,
        name: 'inspiration overview',
      },
      {
        regex: /^\/entdecken\/\w+/,
        name: 'inspiration article',
      },
    ],
  },
  {
    category: 'cruise search',
    pages: [
      {
        regex: /^\/finden\/?$/,
        name: 'cruise search overview',
      },
      {
        regex: /^\/finden\/\?.+/,
        name: 'cruise search results',
        virtPath: '/finden/searchresults',
      },
      {
        regex: /^\/finden\/\w+\/\w+/,
        name: 'cruise search detail',
      },
      {
        regex: /^\/hafen\/[\w-]+/,
        name: 'port detail',
      },
      {
        regex: /^\/finden\/excursions\/\w+/,
        name: 'excursions detail',
      },
    ],
  },
  {
    category: 'cruise',
    pages: [
      {
        regex: /^\/kreuzfahrt\/schiffe$/,
        name: 'ship overview',
      },
      {
        regex: /^\/kreuzfahrt\/schiffe\/\w+$/,
        name: 'ship detail',
      },
    ],
  },
  {
    category: 'campaign',
    pages: [
      {
        regex: /^\/kreuzfahrt\/angebote\/[\w-\/]+$/,
        name: 'campaign',
      },
    ],
  },
  {
    category: 'checkout',
    pages: [
      {
        regex: /^\/buchen\/.*\/meine-reise\/reisende/,
        name: 'booking step 1',
      },
      {
        regex: /^\/buchen\/.*\/meine-reise\/kabine/,
        name: 'booking step 2',
      },
      {
        regex: /^\/buchen\/.*\/meine-reise\/anreise/,
        name: 'booking step 3',
      },
      {
        regex: /^\/buchen\/.*\/meine-reise\/daten/,
        name: 'booking step 4',
      },
      {
        regex: /^\/buchen\/.*\/meine-reise\/versicherung/,
        name: 'booking step 5',
      },
      {
        regex: /^\/buchen\/.*\/meine-reise\/zusammenfassung/,
        name: 'booking step 6',
      },
      {
        regex: /^\/buchen\/\w+\/\w+\/buchung-erfolgt/,
        name: 'success',
      },
    ],
  },
  {
    category: 'cruise planning',
    pages: [
      {
        regex: /^\/planen\/\w+\?e=\d$/,
        name: 'planning overview',
      },
      {
        regex: /^\/planen\/\w+\/kategorie\/\w+$/,
        name: 'planning category',
      },
      {
        regex: /^\/planen\/\w+\/kategorie\/\w+\/\w+$/,
        name: 'planning subcategory',
      },
      {
        regex: /^\/planen\/\w+\/kategorie\/\w+\/tage\/\d+\/port\/\w+\/\w+$/,
        name: 'planning detail',
      },
      {
        regex: /^\/planen\/\w+\/kategorie\/\w+\/tage\/\d+\/port\/\w+$/,
        name: 'planning port',
      },
      {
        regex: /^\/planen\/\w+\/warenkorb$/,
        name: 'planning cart',
      },
      {
        regex: /^\/planen\/\w+\/kalender$/,
        name: 'planning calendar',
      },
      {
        regex: /^\/planen\/\w+\/reservierungen$/,
        name: 'planning reservation',
      },
      {
        regex: /^\/planen\/\w+\/reservierungen\/stonieren$/,
        name: 'planning cancel',
      },
      {
        regex: /^\/planen\/\w+\/erfolg\?isCancelCheckout=true$/,
        name: 'planning cancel success',
      },
      {
        regex: /^\/planen\/\w+\/erfolg$/,
        name: 'planning success page',
      },
    ],
  },
]

// Send onClick search button, "weiter"-button and when the cruise result is zero
export function newPageMetaEventHandler(): AdobeEventHandler {
  return function(
    _mutation: Mutation,
    state: State,
    index: number | undefined,
  ): AdobeEvent[] {
    let totalPrice =
      index && index > 1
        ? `${get(state, 'booking.checkout.price.fullPrice', '0.00').toFixed(2)}`
        : `0.00`
    const event: AdobeEvent = index
      ? {
          event: 'pageView',
          page: {
            ID: 'n/a',
            language: 'de',
          },
          site: {
            CMS: 'BEA',
            environment:
              process.env.STAGE === 'prod' ? 'production' : 'staging',
            name: 'AIDA DE',
          },
          cruise: {
            name: Helpers.buildCruiseName(state),
            ID: Helpers.getCruiseId(state, 'booking.general.cruise.id'),
            ship: Helpers.getShipName(state, 'booking.general.cruise.shipName'),
            departurePort: Helpers.getDeparturePortNameInCheckout(state),
            arrivalPort: Helpers.getArrivalPortNameInCheckout(state),
            route: get(state, 'booking.general.cruise.name', 'n/a'),
            destination: Helpers.getDestination(
              state,
              'booking.general.cruise.region',
            ),
            dateRange: `${Helpers.getStartDate(
              state,
              'booking.general.cruise.departure',
            )} bis ${Helpers.getEndDate(
              state,
              'booking.general.cruise.arrival',
            )}`,
            duration: Helpers.getDuration(
              state,
              'booking.general.cruise.duration',
            ),
            daysToCruise: Helpers.getDaysToCruise(
              state,
              'booking.general.cruise.departure',
            ),
            mandatoryFlight: Helpers.getMandatoryFlight(state, 'booking.general.cruise.mandatoryFlight', 'booking.general.cruise.priceModel'),
          },
          booking: {
            event: 'checkoutView',
            stepNumber: index.toString(),
            tabNumber: '1',
            tabCount: '1',
            price: totalPrice,
          },
        }
      : {
          event: 'pageView',
          page: {
            ID: 'n/a',
            language: 'de',
          },
          site: {
            CMS: 'BEA',
            environment:
              process.env.STAGE === 'prod' ? 'production' : 'staging',
            name: 'AIDA DE',
          },
          cruise: {
            name: Helpers.buildCruiseName(state),
            ID: Helpers.getCruiseId(state, 'booking.general.cruise.id'),
            ship: Helpers.getShipName(state, 'booking.general.cruise.shipName'),
            departurePort: Helpers.getDeparturePortNameInCheckout(state),
            arrivalPort: Helpers.getArrivalPortNameInCheckout(state),
            route: get(state, 'booking.general.cruise.name', 'n/a'),
            destination: Helpers.getDestination(
              state,
              'booking.general.cruise.region',
            ),
            dateRange: `${Helpers.getStartDate(
              state,
              'booking.general.cruise.departure',
            )} bis ${Helpers.getEndDate(
              state,
              'booking.general.cruise.arrival',
            )}`,
            duration: Helpers.getDuration(
              state,
              'booking.general.cruise.duration',
            ),
            daysToCruise: Helpers.getDaysToCruise(
              state,
              'booking.general.cruise.departure',
            ),
            mandatoryFlight: Helpers.getMandatoryFlight(state, 'booking.general.cruise.mandatoryFlight', 'booking.general.cruise.priceModel'),
          },
          booking: {
            event: 'checkoutView',
            stepNumber: '1',
            tabCount: '1',
            price: totalPrice,
          },
        }
    return [event]
  }
}

export function newEmptyPageMetaEventHandler(): AdobeEventHandler {
  return function(
    _mutation: Mutation,
    state: State,
    index: number | undefined,
  ): AdobeEvent[] {
    const event: AdobeEvent = {
          event: 'pageView',
          page: {
            ID: 'n/a',
            language: 'de',
          },
          site: {
            CMS: 'BEA',
            environment:
              process.env.STAGE === 'prod' ? 'production' : 'staging',
            name: 'AIDA DE',
          }
        }
    return [event]
  }
}